$(document).ready(function () {
  $("#aa_cart-notes").change(function () {
    let the_note = $("#aa_cart-notes").val();
    $.ajax({
      url: "/cart/update.js",
      type: "POST",
      data: { note: the_note },
    });
  });

  $(".pplr-c-button.pplr-btn").addClass(
    "product-form__cart-submit btn btn--small btn--medium-ns btn--full btn--secondary upsellyard-atc-button"
  );
});

if (Cookies.get("valid_age") != "true") {
  if (sessionStorage.getItem("valid_age") != "true") {
    $(".cookies_modal").show();
  }
}

if (Cookies.get("accepted_cookies") != "true") {
  $(".cookies-bar").show();
} else {
  setTimeout(() => {
    $(".zsiq_floatmain").addClass("aa_block");
  }, 10000);
}

$(".cookies_bar .costum--btn#removecookie_no").click(function () {
  $(".cookies_bar .warn-message").show();
});

$(".cookies_bar .costum--btn#removecookie").click(function () {
  if ($("#tick_remember").is(":checked")) {
    Cookies.set("valid_age", true);
  } else {
    sessionStorage.setItem("valid_age", true);
  }

  $(".cookies_modal").hide();
});

$(".cookies-bar-accept#removecookie_disclaimer").click(function () {
  $(".cookies-bar").hide();
  Cookies.set("accepted_cookies", true);
  setTimeout(() => {
    $(".zsiq_floatmain").addClass("aa_block");
  }, 10000);
});

$('button[data-target=".newsletter_cookie"]').click(function () {
  sessionStorage.setItem("newsletter_closed", true);
  $(".newsletter_cookie").hide();
});

$("button.dont_subscribe_news.close-popup").click(function () {
  $(".newsletter_cookie").hide();
  Cookies.set("nevershownewsletter", true, { expires: 6 });
});

$("form#newsletterFormPopup").on("submit", function () {
  Cookies.set("newsletter_submitted", true);
});

if (Cookies.get("newsletter_submitted") != "true") {
  if (Cookies.get("nevershownewsletter") != "true") {
    if (sessionStorage.getItem("newsletter_closed") != "true") {
      setTimeout(() => {


        //REMOVIDO DIA 08/11/2023
        //$(".newsletter_cookie").show();
        //



        
      }, 12000);
    }
  }
}

// var e = $('drawer-menu')[0];
// var observer = new MutationObserver(function (event) {
//   $('newsletter_cookie')[0].toggleClass("mnu-z");
//   console.log('open')
// });

// observer.observe(e, {
//   attributes: true,
//   attributeFilter: ['class'],
//   childList: false,
//   characterData: false
// });

$(".header__icon-menu").click(function () {
  $(".newsletter_cookie").addClass("mnu-z");
});

$(".drawer-menu__overlay, .drawer-menu__close-icon").click(function () {
  $(".newsletter_cookie").removeClass("mnu-z");
});



